<template>
<div id="online-mapping">
  <div class="wrapper">
    <img  v-for="(value, key) in images" v-bind:src="value" v-bind:class="key==4?imageMargin:''" />
  </div>
</div>
</template>
<script>
export default{
  data () {
    return {
      images: [require('../../assets/online_pic1.jpg'),
        require('../../assets/online_pic2.jpg'),
        require('../../assets/online_pic3.jpg'),
        require('../../assets/online_pic4.jpg'),
        require('../../assets/online_pic5.jpg'),
        require('../../assets/online_pic6.jpg')],
      imageMargin: 'image-margin'
    }
  }
}
</script>

<style scoped>
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
}
img{
  width: 100%;
  display: block;
}
.image-margin{
  margin-top :-1px;
}
</style>



// WEBPACK FOOTER //
// src/view/app/online-mapping.vue